<div class='page-layout-container'>
  <div class='body-container'>
    <nb-card *ngIf='accessLprSettings; else elseBlock' class='transactions-card'>
      <!--      <div class='col-xl-2 col-left'>-->
      <!--        <app-info-alert class='alert-transparent'-->
      <!--                        infoText="{{ 'SETTINGS.LICENSE_PLATES.EXPLANATION' | translate }}"-->
      <!--                        title="{{ 'SETTINGS.LICENSE_PLATES.TITLE' | translate }}">-->
      <!--        </app-info-alert>-->
      <!--      </div>-->
      <nb-card-body>
        <form [formGroup]='form'>
          <div class='form-group'>
            <h6>{{ 'SETTINGS.LICENSE_PLATES.TITLE' | translate }}</h6>
            <p>{{ 'SETTINGS.LICENSE_PLATES.EXPLANATION' | translate }}</p>
            <div class='row'>
              <div class='col-sm-6'>
                <label class='label'
                       for='licenseWaitTime'>{{ 'SETTINGS.LICENSE_PLATES.LABELS.LICENSE_WAIT_TIME' | translate }}
                  *</label>
                <input [ngClass]="{ 'is-invalid': f['licenseWaitTime'].errors }" formControlName='licenseWaitTime'
                       fullWidth id='licenseWaitTime' nbInput
                       required
                       shape='semi-round'
                       type='number'>
                <app-label-required [errors]="f['licenseWaitTime'].errors"
                                    [label]="'License wait time'"></app-label-required>
              </div>
              <div class='col-sm-6'>
                <label class='label'
                       for='licenseValidTime'>{{ 'SETTINGS.LICENSE_PLATES.LABELS.LICENSE_VALID_TIME' | translate }}
                  *</label>
                <input formControlName='licenseValidTime' fullWidth id='licenseValidTime' nbInput required
                       shape='semi-round' type='number'>
                <app-label-required [errors]="f['licenseValidTime'].errors"
                                    [label]="'License valid time'"></app-label-required>
              </div>
            </div>
            <div class='row'>
              <div class='col-sm-6'>
                <label class='label'
                       for='platesRetentionDays'>{{ 'SETTINGS.LICENSE_PLATES.LABELS.PLATES_RETENTION_DAYS' | translate }}
                  *</label>
                <input formControlName='platesRetentionDays' fullWidth id='platesRetentionDays' nbInput required
                       shape='semi-round' type='number'>
                <app-label-required [errors]="f['platesRetentionDays'].errors"
                                    [label]="'Plates retention days'"></app-label-required>
              </div>
              <div class='col-sm-6'>
                <label class='label'
                       for='requestWaitTime'>{{ 'SETTINGS.LICENSE_PLATES.LABELS.REQUEST_WAIT_TIME' | translate }}
                  *</label>
                <input formControlName='requestWaitTime' fullWidth id='requestWaitTime' nbInput required
                       shape='semi-round'
                       type='number'>
                <app-label-required [errors]="f['requestWaitTime'].errors"
                                    [label]="'Request wait time'"></app-label-required>
              </div>
            </div>
            <label class='label'
                   for='platesLogFolder'>{{ 'SETTINGS.LICENSE_PLATES.LABELS.PLATES_LOG_FOLDER' | translate }}
              *</label>
            <input autocomplete='off' formControlName='platesLogFolder' fullWidth id='platesLogFolder' nbInput
                   required
                   shape='semi-round' type='text'>
            <app-label-required [errors]="f['platesLogFolder'].errors"
                                [label]="'Plates log folder'"></app-label-required>
            <div class='toggle'>
              <nb-toggle formControlName='useLicenseInLogFileName' id='useLicenseInLogFileName'>
                {{ 'SETTINGS.LICENSE_PLATES.LABELS.USE_LICENSE_IN_LOG_FILENAME' | translate }}
              </nb-toggle>
            </div>
            <div class='toggle'>
              <nb-toggle (checkedChange)='getSecondPlatesLogFolderStatus($event)'
                         formControlName='useSecondPlatesLogFolder'
                         id='useSecondPlatesLogFolder'>{{ 'SETTINGS.LICENSE_PLATES.LABELS.USE_SECOND_PLATES_LOG_FOLDER' | translate }}
              </nb-toggle>
            </div>
            <div *ngIf='form.controls.useSecondPlatesLogFolder.value'>
              <label class='label'
                     for='secondPlatesLogFolder'>{{ 'SETTINGS.LICENSE_PLATES.LABELS.SECOND_PLATES_LOG_FOLDER' | translate }}</label>
              <input autocomplete='off' formControlName='secondPlatesLogFolder' fullWidth id='secondPlatesLogFolder'
                     nbInput shape='semi-round' type='text'>
              <div
                *ngIf="form.errors?.['secondPlatesLogFolderUsed'] && (form.touched || form.dirty)"
                class='alert alert-warning'>
                <nb-icon icon='alert-triangle-outline' nbPrefix pack='eva'></nb-icon>
                {{ 'SETTINGS.LICENSE_PLATES.LABELS.SECOND_PLATES_LOG_FOLDER' | translate }}
              </div>
            </div>
            <div class='toggle'>
              <nb-toggle formControlName='saveNoReads'
                         id='saveNoReads'>{{ 'SETTINGS.LICENSE_PLATES.LABELS.SAVE_NO_READS' | translate }}
              </nb-toggle>
            </div>
          </div>
          <div class='form-group'>
            <h6>LPR Host</h6>
            <div class='row'>
              <div class='col-sm-6'>
                <label class='label'
                       for='serviceListenIpAddress'>{{ 'SETTINGS.LICENSE_PLATES.LABELS.SERVICE_LISTEN_IPADDRESS' | translate }}
                  *</label>
                <input formControlName='serviceListenIpAddress' fullWidth id='serviceListenIpAddress' nbInput
                       required
                       shape='semi-round' type='string'>
                <app-label-required [errors]="f['serviceListenIpAddress'].errors"
                                    [label]="'Service Listen IP Address'"></app-label-required>
              </div>
              <div class='col-sm-6'>
                <label class='label'
                       for='listenForTssIpPort'>{{ 'SETTINGS.LICENSE_PLATES.LABELS.LISTEN_FOR_TSS_IPPORT' | translate }}
                  *</label>
                <input formControlName='listenForTssIpPort' fullWidth id='listenForTssIpPort' nbInput required
                       shape='semi-round' type='number'>
                <app-label-required [errors]="f['listenForTssIpPort'].errors"
                                    [label]="'Listen For TSS IPPort'"></app-label-required>
              </div>
            </div>
          </div>
          <div class='form-group'>
            <h6>Tattile</h6>
            <label class='label'
                   for='listenForCamsIpPort'>{{ 'SETTINGS.LICENSE_PLATES.LABELS.LISTEN_FOR_CAMS_IP_PORT' | translate }}
              *</label>
            <input formControlName='listenForCamsIpPort' fullWidth id='listenForCamsIpPort' nbInput required
                   shape='semi-round' type='number'>
            <app-label-required [errors]="f['listenForCamsIpPort'].errors"
                                [label]="'Listen for cams Ip port'"></app-label-required>
          </div>
          <div class='form-group'>
            <h6>Querqus UDP Camera</h6>
            <div class='row'>
              <div class='col-sm-6'>
                <label class='label'
                       for='listenForUdpCamsIpPort'>{{ 'SETTINGS.LICENSE_PLATES.LABELS.LISTEN_FOR_UDP_CAMS_IP_PORT' | translate }}
                  *</label>
                <input formControlName='listenForUdpCamsIpPort' fullWidth id='listenForUdpCamsIpPort' nbInput
                       required
                       shape='semi-round' type='number'>
                <app-label-required [errors]="f['listenForUdpCamsIpPort'].errors"
                                    [label]="'Listen for Udp cams Ip port'"></app-label-required>
              </div>
              <div class='col-sm-6'>
                <label class='label'
                       for='targetUdpCamsIpPort'>{{ 'SETTINGS.LICENSE_PLATES.LABELS.TARGET_UDP_CAMS_IP_PORT' | translate }}
                  *</label>
                <input formControlName='targetUdpCamsIpPort' fullWidth id='targetUdpCamsIpPort' nbInput required
                       shape='semi-round' type='number'>
                <app-label-required [errors]="f['targetUdpCamsIpPort'].errors"
                                    [label]="'Target Udp cams Ip port'"></app-label-required>
              </div>
            </div>
            <div class='toggle'>
              <nb-toggle formControlName='doNotRetrieveImagesForUdpCamera' id='doNotRetrieveImagesForUdpCamera'>
                {{ 'SETTINGS.LICENSE_PLATES.LABELS.DO_NOT_RETRIEVE_IMAGES_FOR_UDP_CAMERA' | translate }}
              </nb-toggle>
            </div>
          </div>
          <div class='form-group'>
            <h6>Inex</h6>
            <label class='label'
                   for='restInterfaceCentralBaseUriListen'>{{ 'SETTINGS.LICENSE_PLATES.LABELS.REST_INTERFACE_CENTRAL_BASE_URI_LISTEN' | translate }}
              *</label>
            <input autocomplete='off' formControlName='restInterfaceCentralBaseUriListen' fullWidth
                   id='restInterfaceCentralBaseUriListen'
                   nbInput required shape='semi-round' type='text'>
          </div>
          <div class='form-actions'>
            <button (click)='onSubmit()' [disabled]='!form.valid || form.pristine' nbButton
                    shape='semi-round' status='success' type='submit'>{{ 'BUTTONS.SAVE' | translate }}
              <nb-icon icon='edit-2'></nb-icon>
            </button>
            <button (click)='resetForm()'
                    nbButton outline shape='semi-round' status='warning'>{{ 'BUTTONS.DEFAULT' | translate }}
              <nb-icon icon='close-outline' pack='eva'></nb-icon>
            </button>
          </div>
        </form>
      </nb-card-body>
      <nb-card-footer></nb-card-footer>
    </nb-card>
    <ng-template #elseBlock>
      <h5>{{ 'SETTINGS.ACCESS' | translate }}</h5>
    </ng-template>
  </div>
</div>
